import { http } from "../../../services/apiCommunicated/Http.interceptor";
import { HistoricInterface } from './interface/Historic';

const URL: string = '/api/v1/Historicos/Notificacao';

export const getHistoric = (id: string) => {
    return http.get<HistoricInterface[]>(`${URL}/${id}`);
}
